 import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
const SelectLabelListNameUI =({getListObject,item})=>{

    const [active , setActive] = useState({status:false});
    return(<>
    
 <label className={"checkbox-outer  "}  style={{marginTop:"-5px",marginLeft:"-5px"}}>
                                        
                                        <span style={{position:"relative",top: "-1px" ,left:"-2px",fontSize:"14px",textTransform: "capitalize"}}>{active?.status?"Deselect":"Select"} {item?.mime_type}</span>
                                       
                                                <input  type={"checkbox"} title={item?.file_name}
                                                 className="input-textbox"  checked= {active?.status} value={item?.id} name={"selectFile"}  
     onChange={e=>{ setActive({...active,status:!active.status}); getListObject(item)
        
        
       }
       
    }
    />
                                                   <span class={"square"} style={{border:"3px solid rgba(144, 202, 249,1)",transform:"scale(0.6)",borderRadius:"5px",}}></span>
                                          </label> 
    </>)
}
export default SelectLabelListNameUI;
 
 